<div class="adhesion-footer">
  <ng-content></ng-content>
</div>
